function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.1562 19.4566C23.8594 19.4566 24.2812 18.5191 23.7188 17.9566L10.4062 4.26912C9.89062 3.70662 9 4.08162 9 4.8785V24.9879C9 25.7379 9.84375 26.1597 10.4062 25.5972L14.4375 21.4254L16.9219 27.4722C17.1094 27.8941 17.625 28.1285 18.0469 27.941L20.3438 26.9566C20.7656 26.7691 20.9531 26.2535 20.7656 25.8316L18.1875 19.4566H23.1562Z",
  fill: "#D5D7DE"
});

var SvgMouse = function SvgMouse(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mouse.83556da4.svg";
export { ForwardRef as ReactComponent };